<template lang="pug">
  validation-observer(ref='observer' tag='form')
    app-modal(
      :closeOutside="false",
      :titulo="`${isBloqueio ? 'Bloqueio' : 'Desbloqueio'} de Usuário`",
      :width="1000",
      @closeModal="closeModal()",
    )
      template(slot="body")
        el-col.margin-top(:span="24")
          validation-provider(rules="required", v-slot="{ errors }", name="observacao")
            app-label(
              :label="`Motivo do ${isBloqueio ? 'bloqueio' : 'desbloqueio'}:`",
              :required="true"
            )
            el-input.input(
              type="textarea"
              placeholder="Motivo..."
              :class="{'erro' : errors.length}",
              v-model="observacao"
            )
            span.help.erro {{ errors[0] }}
        el-col.margin-top-30(:span="24")
          validation-provider(rules="", v-slot="{ errors }", name="arquivo")
            app-label(label="Anexo:", :required="false")
            app-upload-area(
              id="modalAlterarPerfil"
              :target="urlUpload"
              :fileType="validExtensions"
              v-model="documento"
              :onSuccess="onSuccess"
              @removerDocumento="removeArquivo"
              :errors="errors"
              :hasDownloadButton="false"
            )
      template(slot="footer")
        div.buttons
          el-button.cancelarButton(@click="closeModal()")
            i.fas.fa-times
            |  Cancelar
          el-button(type="primary",key="botao-confirma",@click="save()")
            i.fas.fa-check
            |  Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppUploadArea from '@/components/AppUploadArea'

export default {
  components: {
    AppModal,
    AppLabel,
    AppUploadArea
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    usuario: {
      type: Object
    },
    isBloqueio: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      documento: undefined,
      observacao: '',
      validExtensions: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD
    }
  },

  methods: {
    ...mapActions({
      bloquearUsuario: 'usuario/bloquearUsuario'
    }),

    closeModal () {
      this.isCamposModal = true
      this.$emit('closeModal')
    },

    onSuccess (id, resumableFile, fileKey) {
      this.documento = {
        key: fileKey,
        nome: resumableFile.fileName
      }
    },

    removeArquivo () {
      this.documento = undefined
    },

    async save () {
      if (!await this.$refs.observer.validate()) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.PREENCHA_TODOS_CAMPOS)
        return
      }
      await this.bloquearUsuario({
        isBloqueio: this.isBloqueio,
        observacao: this.observacao,
        documento: this.documento,
        loginUsuario: this.usuario.cpfCnpj
      })
      this.closeModal()

      if (this.isBloqueio) {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.USUARIO_BLOQUEADO_SUCESSO
        )
      } else {
        this.closeModal()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.USUARIO_DESBLOQUEADO_SUCESSO
        )
      }
    }
  }

}
</script>

<style scoped lang="scss">
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  .margin-top-30 {
    margin-top: 30px;
  }

  .margin-top {
    margin-top: 10px;
  }

  .margin-right {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalBloquearUsuario.vue